import { storeToRefs } from "pinia";

import { useEmailCampaignsStore } from "@stores/survey/mailing/emailCampaigns";
import { createFilters } from "@/utils/composables/filters/createFilters";

export const useEmailCampaignsFilters = () => {
  const emailCampaignsStore = useEmailCampaignsStore();

  const { clearFilters, searchEmailCampaigns } = emailCampaignsStore;
  const { emailCampaignsStatusFilter } = storeToRefs(emailCampaignsStore);

  return createFilters({
    filters: [
      {
        id: "campaignStatus",
        label: "Campaign status",
        options: [
          { label: "Draft", value: "draft" },
          { label: "Scheduling", value: "queuing" },
          { label: "Scheduled", value: "queued" },
          { label: "Sending", value: "sending" },
          { label: "Sent", value: "sent" },
          { label: "Suspended", value: "suspended" },
        ],
        model: emailCampaignsStatusFilter,
      },
    ],
    search: searchEmailCampaigns,
    clear: clearFilters,
  });
};
